import { canonicalUrl } from './site';

export interface PublicPageSeo {
  path: string;
  title: string;
  description: string;
}

export const PUBLIC_PAGE_SEO: PublicPageSeo[] = [
  {
    path: '/',
    title: 'RideMaadi – Motorcycle Riding & Group Ride App',
    description:
      'RideMaadi helps motorcycle riders and riding groups discover communities, plan group rides, and ride together. A group ride planning app for riders and clubs.',
  },
  {
    path: '/features',
    title: 'Motorcycle Group Ride App Features | RideMaadi',
    description:
      'Explore RideMaadi features for motorcycle ride planning: routes, meeting points, group coordination, and tools for riding groups and motorcycle clubs.',
  },
  {
    path: '/how-it-works',
    title: 'How to Plan Group Motorcycle Rides | RideMaadi',
    description:
      'Learn how RideMaadi works — sign in, join a riding group, organize a group ride, and stay coordinated with fellow riders from start to finish.',
  },
  {
    path: '/for-riders',
    title: 'Motorcycle Riding App for Individual Riders | RideMaadi',
    description:
      'Find riding groups, join organized motorcycle rides, and connect with fellow riders. RideMaadi helps individual riders take part in well-planned group rides.',
  },
  {
    path: '/for-riding-groups',
    title: 'Motorcycle Club & Riding Group App | RideMaadi',
    description:
      'Organize club rides, invite members, and manage your motorcycle community. RideMaadi gives riding groups and clubs tools to plan and coordinate group rides.',
  },
  {
    path: '/about',
    title: 'About RideMaadi – Motorcycle Riding Community App',
    description:
      'About RideMaadi: a motorcycle riding and group ride app for riders and riding communities. Built to help groups plan rides and ride together with confidence.',
  },
  {
    path: '/privacy',
    title: 'Privacy Policy – RideMaadi',
    description:
      'RideMaadi privacy policy — how we handle account information, ride data, and your privacy when using our motorcycle group ride app.',
  },
  {
    path: '/terms',
    title: 'Terms of Use – RideMaadi',
    description:
      'RideMaadi terms of use for riders and riding groups using our motorcycle ride planning and group coordination application.',
  },
];

export function seoForPath(path: string): PublicPageSeo {
  return PUBLIC_PAGE_SEO.find((page) => page.path === path) ?? PUBLIC_PAGE_SEO[0]!;
}

export const SITEMAP_URLS = PUBLIC_PAGE_SEO.map((page) => canonicalUrl(page.path));
